<div fxLayout="row" fxLayoutAlign="space-between start" style="height: 80vh">
  <iframe width="100%" height="100%" [src]="reportUrl" frameborder="1" style="border:1" allowfullscreen></iframe>
</div>